export default function Error({ error, className = "" }) {
    if (error) {
        return (
            <span className={`text-sm text-red-700 mt-1 ${className}`}>
                {error}
            </span>
        );
    }
    return null;
}
